import { render, staticRenderFns } from "./partnerAddressBox.vue?vue&type=template&id=fcfc519a&"
import script from "./partnerAddressBox.vue?vue&type=script&lang=ts&"
export * from "./partnerAddressBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports